/* eslint-disable  */
function handleSearchBlock() {
  const btnSearch = document.querySelector('.btn-search');
  const searchBlock = document.querySelector('.search-block-form ');
  const searchInput = document.querySelector('.search-block-form form input.form-search');
  const mainMenu = document.querySelector('.header-main-section nav[role="navigation"]');

  const btnClose = document.querySelector('.search-block-form .btn-close-search');

  const breakpoint = window.matchMedia('(max-width: 1223px)');
  const hamburger = document.querySelector('.btn-hamburger');

  if (!btnSearch || !searchBlock) return;

  function reset() {
    searchBlock.classList.remove('active');

    btnSearch.classList.remove('is-hidden');
    if (mainMenu) mainMenu.classList.remove('is-hidden');

    hamburger.classList.remove('hidden');

	
    document.body.classList.remove('body-overlay-no-delay');
    document.body.classList.remove('body-overlay-no-delay');
		

  }

  btnSearch.addEventListener('click', (e) => {
    e.stopPropagation();
    closeActiveDropdown(e.target);
    searchBlock.classList.add('active');
    searchInput.focus();
    btnSearch.classList.add('is-hidden');

    document.body.classList.add('body-overlay-no-delay');

    if (breakpoint.matches) {
      hamburger.classList.add('hidden');
    }
  });

  if (btnClose) {
    btnClose.addEventListener('click', (e) => {
      reset();
    });
  }

  breakpoint.addEventListener('change', () => {
    reset();
  });

  searchBlock.addEventListener('click', (e) => {
    e.stopPropagation();
  });

  window.addEventListener('click', (e) => {
    if (!e.target.isEqualNode(searchBlock)) {
      reset();
    }
  });
}

function bodyOverlay() {
  const header = document.querySelector('header[role="banner"]');

  if (!header) return;

  const bodyHeight = document.body.offsetHeight;
  const headerMainMenuOffsetTop = header.offsetTop + header.getBoundingClientRect().height;

  document.body.style.setProperty('--overlay-top', headerMainMenuOffsetTop + 'px');
  document.body.style.setProperty('--overlay-height', bodyHeight + 'px');
}

function closeActiveDropdown(target) {
  const btnActiveArrows = document.querySelectorAll(
    '.main-menu-desktop li.has-children[data-level="0"] >.menu-link-wrap',
  );

  btnActiveArrows.forEach((button) => {
    if (!button.isEqualNode(target)) {
      button.querySelector('.btn-arrow').classList.remove('active');
      button.parentElement.classList.remove('active');

      const menuDropdown = button.closest('li');

      if (menuDropdown) {
        menuDropdown.querySelector('ul').classList.remove('active');
      }
    }
  });
}

function handleMenuDropdown() {
  const btnArrows = document.querySelectorAll('.main-menu-desktop li.has-children[data-level="0"] >.menu-link-wrap');
  const btnCloseSearch = document.querySelector('.search-block-form .btn-close-search');

  if (!btnArrows) return;

  btnArrows.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const subMenu = btn.closest('li').querySelector('ul');

      if (btnCloseSearch) {
        btnCloseSearch.click();
      }

      closeActiveDropdown(btn);

      if (subMenu) {
        subMenu.parentElement.classList.toggle('active');
        subMenu.classList.toggle('active');
        btn.querySelector('.btn-arrow').classList.toggle('active');

        if (subMenu.classList.contains('active')) {
          document.body.classList.add('body-overlay-no-delay');
        } else {
          document.body.classList.remove('body-overlay-no-delay');
        }
      }
    });
  });
}

function createBackButton() {
  const subMenus = document.querySelectorAll('.main-menu-mobile ul.main-menu__submenu');
  if (!subMenus.length > 0) return;

  subMenus.forEach((subMenu) => {
    const subMenuParent = subMenu.parentElement;
    const parentLink = subMenuParent.querySelector('.main-menu__link').cloneNode(true);

    const backBtn = document.createElement('li');
    backBtn.classList.add('menu-back');
    backBtn.appendChild(parentLink);
    subMenu.prepend(backBtn);

    backBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      e.preventDefault();
      backBtn.parentElement.parentElement.parentElement.style.height = 'auto';
      subMenuParent.classList.remove('is-active');
      subMenu.classList.remove('is-active');
      subMenuParent.closest('ul.main-menu__submenu')?.classList.add('is-active');
    });
  });
}

function showSlideSubMenu() {
  const subMenuExpandButtons = document.querySelectorAll(
    '.main-menu-mobile .menu-main__item.has-children .menu-link-wrap',
  );

  if (!subMenuExpandButtons.length > 0) return;

  subMenuExpandButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      btn.parentElement?.classList.add('is-active');
      btn.parentElement.parentElement.style.height = '0';
      btn.nextElementSibling.classList.add('is-active');
      btn.closest('ul.main-menu__submenu')?.classList.remove('is-active');
    });
  });
}

function resetMobileMenu() {
  const menuItems = document.querySelectorAll('.main-menu-mobile .main-menu__item.has-children');
  const subMenus = document.querySelectorAll('.main-menu-mobile .main-menu__submenu');

  if (!menuItems.length > 0) return;

  menuItems.forEach((item) => item.classList.remove('is-active'));

  subMenus.forEach((item) => item.classList.remove('is-active'));
}

function handleMobileMenu() {
  const hamburger = document.querySelector('.btn-hamburger');
  const mobileMenu = document.querySelector('.main-menu-mobile');
  const btnClose = document.querySelector('.main-menu-mobile .btn-close');

  if (!hamburger || !mobileMenu) return;

  resetMobileMenu();

  hamburger.addEventListener('click', () => {
    mobileMenu.classList.add('active');
    document.body.classList.add('main-menu-open');
    document.body.classList.add('body-overlay');
  });

  btnClose.addEventListener('click', () => {
    mobileMenu.classList.remove('active');
    document.body.classList.remove('main-menu-open');
    document.body.classList.remove('body-overlay');
  });
}

function initMobileMenu() {
  createBackButton();
  showSlideSubMenu();
}

function setVhUnit() {
  let vh = window.innerHeight * 0.01;

  document.documentElement.style.setProperty('--vh', `${vh}px`);

  // We listen to the resize event
  window.addEventListener('resize', () => {
    vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  });
}

function stickyNav() {
  const mainHeader = document.querySelector('.header-main-section');
  const brandingBlock = document.querySelector('#block-appgroup-site-branding');

  if (!mainHeader || !brandingBlock) return;

  let threshold = 40;

  const infoBar = document.querySelector('.info-bar');

  const brandingBlockOffsetTop = brandingBlock.getBoundingClientRect().top;

  if (infoBar) {
    threshold += infoBar.getBoundingClientRect().height;
  }

  if (window.scrollY > 40) {
    mainHeader.classList.add('is-sticky');
  }
  window.addEventListener('scroll', () => {
    if (window.pageYOffset > threshold && window.pageYOffset > brandingBlockOffsetTop + 1) {
      mainHeader.classList.add('is-sticky');
    } else {
      mainHeader.classList.remove('is-sticky');
    }
  });
}

function whatWeDoMenu() {
  const whatWeDoLink = document.querySelector('.main-menu-desktop .main-menu .main-menu__link.what-we-do');
  if (!whatWeDoLink) return;

  whatWeDoLink.parentElement.parentElement.classList.add('what-we-do');
}

window.addEventListener('DOMContentLoaded', () => {
  setVhUnit();
  initMobileMenu();
  handleMenuDropdown();
  handleSearchBlock();
  handleMobileMenu();
  stickyNav();
  whatWeDoMenu();

  window.addEventListener('click', (e) => {
    closeActiveDropdown(e.target);
    document.body.classList.remove('body-overlay-no-delay');
  });

  setTimeout(() => {
    bodyOverlay();
  }, 1000);
});
